import React, { useState } from "react";
import sideMenuItems from "../SideBar/Menu";
import { NavLink } from "react-router-dom";
import { ChevronDown } from "lucide-react";

interface SideMenuProps {
  closeMenu: () => void;
}

const SideMenu: React.FC<SideMenuProps> = ({ closeMenu }) => {
  const [openMenus, setOpenMenus] = useState<{ [key: number]: boolean }>({});

  const toggleSubMenu = (key: number) => {
    setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className='bg-white w-full h-fit p-4 z-40 shadow-lg'>
      {sideMenuItems.map((item, key) => (
        <div key={key}>
          {item.subMenu ? (
            <div>
              <div
                onClick={() => toggleSubMenu(key)}
                className='flex items-center justify-between py-3 px-3 text-black font-medium rounded-lg cursor-pointer'
              >
                <div className='flex items-center'>
                  {item?.icon && <item.icon className='h-5 w-5' />}
                  <span className='ml-3 text-sm'>{item?.name}</span>
                </div>
                <ChevronDown
                  className={`h-4 w-4 transition-transform duration-300 ${
                    openMenus[key] ? "rotate-180" : ""
                  }`}
                />
              </div>
              {openMenus[key] &&
                item.subMenu.map((subItem, subKey) => (
                  <NavLink
                    key={subKey}
                    to={subItem.to ?? "/"}
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      `block ml-8 mt-2 text-sm rounded-md px-3 py-2 ${
                        isActive ? "text-theme700 font-semibold" : "text-black"
                      }`
                    }
                  >
                    {subItem.icon && (
                      <subItem.icon className='inline-block w-4 h-4 mr-2' />
                    )}
                    {subItem.title}
                  </NavLink>
                ))}
            </div>
          ) : (
            <NavLink
              to={item.to ?? "/"}
              onClick={closeMenu}
              className={({ isActive }) =>
                `flex items-center py-3 px-3 text-sm font-medium rounded-lg ${
                  isActive ? "text-theme700" : "text-black"
                }`
              }
            >
              {item.icon && <item.icon className='h-5 w-5' />}
              <span className='ml-3'>{item.name}</span>
            </NavLink>
          )}
        </div>
      ))}
    </div>
  );
};

export default SideMenu;
